import { render, staticRenderFns } from "./cuttingSheetScanPage.vue?vue&type=template&id=63cb53bb&scoped=true&"
import script from "./cuttingSheetScanPage.vue?vue&type=script&lang=js&"
export * from "./cuttingSheetScanPage.vue?vue&type=script&lang=js&"
import style0 from "./cuttingSheetScanPage.vue?vue&type=style&index=0&id=63cb53bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cb53bb",
  null
  
)

export default component.exports